import StoreForm from '../form/StoreForm';
import React from 'react'
import withLayout from "../../../layout/withLayout";
import PropTypes from "prop-types";
import {lifecycle} from "recompose";

const AddStore = (props) => {
    return(
        <StoreForm {...props}/>
    )
}

AddStore.propTypes = {
    clearState: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount() {
        this.props.clearState()
    }
})(withLayout(AddStore))



// WEBPACK FOOTER //
// ./src/modules/store/component/add/AddStore.js